import {QueryableEnum, QueryableFlag, QueryableProperty} from '../queryableProperty';
import {CommunicationType} from '../../../communication/data/communicationType';
import {FlagService} from '../../../flag/services/flag.service';

export class ObjectProperties {
  properties: QueryableProperty[];
  sortingPropertyName: string;
  sortingDescending: boolean;
}

export class CommunicationProperties extends ObjectProperties {
  constructor(flagService: FlagService) {
    super();
    this.properties = [
      // new QueryableProperty('wildcard', 'Wildcard', 'wildcard'),
      new QueryableProperty('id', 'Id', 'id', false),
      new QueryableProperty('customerId', 'Contact', 'customer', false),
      new QueryableProperty('personName', 'Name', 'string', false),
      // new QueryableProperty('title', 'Title', 'string'),
      new QueryableProperty('description', 'Content', 'string', false),
      new QueryableProperty('createdBy', 'Creator', 'worker'),
      new QueryableEnum('type', 'GODH.Application.Core.Entities.Communication.CommunicationType', 'Type', 'enum', false,
        {},
        [{name: '', value: CommunicationType.Phone, icon: 'fas fa-phone', color: undefined},
          {name: '', value: CommunicationType.Email, icon: 'fas fa-at', color: undefined},
          {name: '', value: CommunicationType.Mail, icon: 'fas fa-envelope', color: undefined},
          {name: '', value: CommunicationType.InPerson, icon: 'fa-user', color: undefined},
          {name: '', value: CommunicationType.SMS, icon: 'fa-solid fa-message-sms', color: undefined}]),
      new QueryableEnum('outgoing', 'System.Boolean', 'Direction', 'enum', false,
        {},
        [{name: 'In', value: false, icon: undefined, color: undefined},
          {name: 'Out', value: true, icon: undefined, color: undefined}]),
      // new QueryableEnum('flagged', 'System.Boolean', 'Flagged', 'enum', false,
      //   [{name: 'No', value: false, icon: 'fas fa-lg fa-times', color: undefined},
      //     {name: 'Yes', value: true, icon: 'fas fa-lg fa-check', color: undefined}]),
      new QueryableFlag(flagService, 'flagColor', 'System.Integer', 'Flag', false,
        {highlightMode: 'size'}),
      new QueryableProperty('eventDate', 'Event Date', 'date'),
    ];
    this.sortingPropertyName = 'eventDate';
    this.sortingDescending = true;
  }
}
